export enum EPaymentQueryKey {
  ADMIN_LIST_FIAT_TRANSACTIONS = 'admin-list-fiat-transactions',
  ADMIN_COMPLETE_WITHDRAWAL_FIAT = 'admin-complete-withdrawal-fiat',
  ADMIN_FIAT_DEPOSIT = 'admin-fiat-deposit',
}
